import {
    FetchState,
} from "@/shared/types";
import {
    ReimbursementFailurePageRequestModel,
    ReimbursementFailurePageResponseModel,
    ReimbursementFailureState,
    ReimbursementFailureDetailModel
} from "../types";
import * as BankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";

export const initialState: ReimbursementFailureState = {
    listFetchState: FetchState.Uninitialized,
    itemFetchState: FetchState.Uninitialized,
    pageNumber: -1,
    numberOfPages: -1,
    totalCount: -1,
    items: null,
    reimbursementId: null,
    detailItem: null
};

export const useReimbursementFailureStore = defineStore("reimbursementFailure", {
    state: (): ReimbursementFailureState => (_.cloneDeep(initialState)),
    getters: {
        isListLoaded: state => state.listFetchState === FetchState.Loaded,
        isDetailLoaded: state => state.itemFetchState === FetchState.Loaded,
        getLoadedItems: state => state.items,
        pageRange () {
            return _.range(1, this.numberOfPages + 1);
        },
    },
    actions: {
        setItems (args: { page: number, data: ReimbursementFailurePageResponseModel }) {
            this.items = args.data.items;
            this.pageNumber = args.data.pageNumber;
            this.numberOfPages = args.data.numberOfPages;
            this.totalCount = args.data.totalCount;
            this.listFetchState = args.data.items ? FetchState.Loading : FetchState.Loaded;
        },
        setItem (data: ReimbursementFailureDetailModel) {
            this.detailItem = data;
        },
        setListFetchState (fetchState: FetchState) {
            this.listFetchState = fetchState;
        },
        setItemFetchState (fetchState: FetchState) {
            this.itemFetchState = fetchState;
        },
        setReimbursementId (reimbursementId: number) {
            this.reimbursementId = reimbursementId;
        },
        removeFromListById (reimbursementId) {
            this.items.splice(this.items.findIndex(item => item.reimbursementId === reimbursementId), 1);
        },
        loadItems (request: ReimbursementFailurePageRequestModel) {
            if (this.pageNumber === request.pageNumber && this.listFetchState === FetchState.Loading) {
                return Promise.resolve();
            }
            this.setListFetchState(FetchState.Loading);
            return BankService.getReimbursementFailures(request)
                .then(v => {
                    this.setItems({ page: request.pageNumber, data: v.data });
                    this.setListFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setListFetchState(FetchState.Loaded);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        resolveById (reimbursementId) {
            if (this.reimbursementId === reimbursementId && this.itemFetchState === FetchState.Loading) {
                return Promise.resolve();
            }
            this.setItemFetchState(FetchState.Loading);
            this.setReimbursementId(reimbursementId);
            return BankService.resolveReimbursementFailure(reimbursementId)
                .then(v => {
                    this.setItem(v.data);
                    this.setItemFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setItemFetchState(FetchState.Loaded);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        loadDetailById (reimbursementId) {
            if (this.reimbursementId === reimbursementId && this.itemFetchState === FetchState.Loading) {
                return Promise.resolve();
            }
            this.setReimbursementId(reimbursementId);
            this.setItemFetchState(FetchState.Loading);
            return BankService.getReimbursementFailureDetail(reimbursementId)
                .then(v => {
                    this.setItem(v.data);
                    this.setItemFetchState(FetchState.Loaded);
                })
                .catch(err => {
                    this.setItemFetchState(FetchState.Loaded);
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});
